<template>
	<div class="section-gifts">
		<div class="gifts-container">
			<p>Choose a virtual gift to go with your message!</p>
			<div class="gifts">
				<gift-item :type="constant.ENVELOPE" :price="constant.ENVELOPE_PRIZE" />
				<gift-item :type="constant.BOX" :price="constant.BOX_PRIZE" />
				<gift-item :type="constant.BALLOONS" :price="constant.BALLOONS_PRIZE" />
				<gift-item :type="constant.CHOCO" :price="constant.CHOCO_PRIZE" />
				<gift-item :type="constant.FLOWERS" :price="constant.FLOWERS_PRIZE" />
				<gift-item :type="constant.BEAR" :price="constant.BEAR_PRIZE" />
			</div>
		</div>
		<div class="buttons">
			<button-left @click.native.prevent="$emit('back')">Back</button-left>
			<button-right @click.native.prevent="submit()" :class="{'disabled': this.$store.state.form.gift === null}">Next</button-right>
		</div>

		<div class="gift-popup" v-if="popup">
			<div class="gift-popup__bg" @click.self="closePopup"></div>
			<div class="gift-popup__content">
				<h2>You have chosen to add a gift which is FREE</h2>

				<p>This means that you will not be donating to the foundation as part of your message of love.<br> Are you sure?</p>

				<button-left @click.native.prevent="closePopup()">Go Back</button-left>
				<p>So I can add my donation</p>

				<button-right @click.native.prevent="submit(true);">Continue without donating</button-right>
				<p>I don’t want to help the foundation</p>
				<a href="#" class="gift-popup__close" @click.prevent="closePopup()">&times;</a>
			</div>
		</div>
	</div>
</template>

<script>
import { gifts } from '@/constants';
import ButtonRight from '../ButtonRight';
import ButtonLeft from '../ButtonLeft';
import GiftItem from '../GiftItem';

export default {
	components: { ButtonRight, ButtonLeft, GiftItem },
	data () {
		return {
			popup: false, // -> Show the popup?
		};
	},
	computed: {
		constant () {
			return gifts;
		},
	},
	methods: {
		submit (force = false) {
			if (this.$store.state.form.gift === null) {
				return;
			}

			if (force || this.$store.state.form.gift > 0) {
				this.$emit('success');
			} else {
				this.openPopup();
			}
		},
		openPopup () {
			this.popup = true;
		},
		closePopup () {
			this.popup = false;
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';
	@import '../../assets/less/form.less';

	.gifts-container { padding: 1rem 1rem 0; background-color: #fff; text-align: center; }
	.gifts { display: flex; flex-wrap: wrap; justify-content: space-between; }

	.gift-popup { .top-left-f(0, 0, 1000); .size(100vw,100vh); display: flex;
		&__bg { .top-left(); .size(100%); background-color: fade(black, 60); }
		&__content { position: relative; z-index: 1001; max-width: 400px; margin: auto; align-self: center; padding: 3rem 2.5rem; background-color: #fff;
			h2 { font-size: 1rem; }
			p { margin-bottom: 1.6rem; }
			.button { padding: 14/16rem; font-size: 14/16rem; }
			.button + p { margin-top: 0.5rem; }
			.button:last-of-type + p { margin-bottom: 0; }
		}
		.gift-popup__close { .top-right(); padding: .8rem .5rem; color: white; background-color: @blue; .bold(); font-size: 2rem; line-height: 1rem; text-decoration: none; }
	}

	@media @mobile {
		.section-gifts { padding: 6vw 3vw 12vw; }
		.gifts-container { padding: 0; background-color: @greyLight; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheFormGift.vue